<template>
  <div class="main-background filter-page-container">
    <div class="filter-page-back-button" @click="$emit('setIsChangePage', 'cart')">
      <chevron-left-icon class="back-button-icon" />
      <p class="back-button-text">Back to cart</p>
    </div>
    <div id="makeOrderContent" class="make-order-page-inputs-container" :style="{ height: formHeight + 'px' }">
      <p class="make-order-page-main-title">Placing an order</p>
      <p class="make-order-page-under-main-title">Enter your contact details</p>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Name</label>
        <input v-model="customerName" @keyup.enter="handleEnterKey" @change="setSaveCustomerInfo"
          class="make-order-input" @focus="isOpenKeyboard(true)" @blur="isOpenKeyboard(false)" minlength="3"
          maxlength="30" type="text" id="text" placeholder="Ivan">
        <p v-if="isRequiredError && customerName.length < 3" class="error-message-text">Mandatory field</p>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Second Name</label>
        <input v-model="customerSecondName" @keyup.enter="handleEnterKey" @change="setSaveCustomerInfo"
          class="make-order-input" @focus="isOpenKeyboard(true)" @blur="isOpenKeyboard(false)" minlength="3"
          maxlength="30" type="text" id="text" placeholder="Ivanov">
        <p v-if="isRequiredError && customerSecondName.length < 3" class="error-message-text">Mandatory field</p>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">Phone number</label>
        <input v-model="onOrderPhoneNumber" @keyup.enter="handleEnterKey" @input="validatePhoneNumber" inputmode="tel"
          @change="setSaveCustomerInfo" class="make-order-input" @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)" type="text" id="text" placeholder="(123) 123-4567">
        <p v-if="!isValidPhoneNumber" class="error-message-text">Enter the phone number in the format (XXX) XXX-XXXX</p>
      </div>
      <p class="make-order-page-title">Delivery address</p>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="text">City</label>
        <input v-model="customerCity" @keyup.enter="handleEnterKey" @input="debouncedSearch" class="make-order-input"
          @focus="isOpenKeyboard(true)" @blur="isOpenKeyboard(false)" type="text" id="textCity"
          placeholder="Enter the city">
        <p v-if="isRequiredError && !branchCity" class="error-message-text">Mandatory field</p>
        <div v-if="searchedTowns.length && isShowCitys" class="searched-order-towns">
          <vue-perfect-scrollbar class="perfect-town-scrollbar">
            <p v-for="town of searchedTowns" :key="town.uuid_city" @click="onClickToCity(town)"
              class="searched-order-town-item">{{ town.name }}</p>
          </vue-perfect-scrollbar>
        </div>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label">Branch of Nova Poshta</label>
        <input v-model="customerPostNumber" @keyup.enter="handleEnterKey" @focus="setIsShowBranch" autocomplete="off"
          class="make-order-input" @blur="isOpenKeyboard(false)" type="text" id="branch-list" placeholder="Branch №">
        <p v-if="isRequiredError && !usedBranch" class="error-message-text">Mandatory field</p>
        <div :class="`searched-order-posts ${isShowranch ? 'show' : ''}`">
          <input v-focus id="branch-list" @keyup.enter="handleEnterKey" type="text" placeholder="Search"
            v-model="filterPostText" @focus="isOpenKeyboard(true)" @blur="isOpenKeyboard(false)"
            class="searched-input-post">
          <div v-if="!searchedBranch.length" class='branch-loading-container'>
            <loader-spinner class="branch-loading-spinner" />
            <p id="branch-list" class="branch-loading-text">Please wait while loading available branches</p>
          </div>
          <vue-perfect-scrollbar class="perfect-town-scrollbar">
            <p v-for="branch of filteredPostNumbers" :key="branch.id" @click="onCLickToBranch(branch)"
              class="searched-order-town-item">{{ branch.text }}</p>
          </vue-perfect-scrollbar>
        </div>
      </div>

    </div>
    <div class="bottom-filter-button-container">
      <div class="final-price-container">
        <p class="final-price">In total</p>
        <p class="final-price">{{ cartElements.sumTotal }} USD</p>
      </div>
      <div class="error-message-container" v-if="isShowError">
        <p class="error-message-text">There was a problem during checkout, please try again</p>
      </div>
      <button v-if="!isLoadingFetch" class="filtration-button" @click="setMakeOrder">
        To order
      </button>
      <button v-else class="filtration-button">
        <loader-spinner class="button-loading-spinner" :LoaderColor="true" />
      </button>
    </div>
  </div>
</template>

<script>

import { ChevronLeftIcon } from 'vue-feather-icons';
import debounce from 'lodash/debounce';
import { GET_CITYS, GET_ORDER_BRANCH } from '../helpers/requests';
import LoaderSpinner from '../../../components/LoaderSpinner.vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapMutations } from "vuex"

export default {
    name: "make-order-page",
    components: {
        ChevronLeftIcon,
        LoaderSpinner,
        VuePerfectScrollbar
    },
    props: {
        addedToCardProducts: {
            type: Array,
            required: true
        },
        telegram: {
          type: Object,
          required: true
        }
    },
    data() {
        return {
            productCounter: 0,
            customerName: '',
            customerSecondName: '',
            customerPostNumber: '',
            onOrderPhoneNumber: '+380',
            customerCity: '',
            filterPostText: '',
            isWrongFormat: false,
            isLoading: true,
            branchCity: null,
            usedBranch: null,
            isShowranch: false,
            searchedTowns: [],
            searchedBranch: [],
            filteredPostNumbers: [],
            resultMakePrder: null,
            isShowError: false,
            isLoadingFetch: false,
            isValidPhoneNumber: true,
            isRequiredError: false,
            formHeight: 0,
            startHeight: 0,
            isShowCitys: false,
            isHideMainButton: false
        }
    },
    mounted() {
      this.formHeight = window.innerHeight - 120 - 125
      // let startHeight = window.innerHeight - 120 - 115
      window.scrollTo(0, 0);
      window.addEventListener('click', (event) => {
        if (this.isShowranch && event.target.id !== 'branch-list') {
          this.isShowranch = false
        }
      })
      setTimeout(() => {
        const {firstName, lastName, phoneNumber } = this.customCustomerInfo
        const { first_name, last_name, phone } = this.getOrderId.customer

        this.customerName = firstName || first_name
        this.customerSecondName = lastName || last_name
        this.onOrderPhoneNumber = phoneNumber || phone
      }, 100)
      document.body.addEventListener('click', (event) => {
        let target = event.target
        if (target.id === 'textCity') {
          this.isShowCitys = true
        } else {
          this.isShowCitys = false
        }
        
      })
      this.telegram.MainButton.onClick(() => {
        const focusedElement = document.activeElement;
        const inputs = document.querySelectorAll('input');
        for (const input of inputs) {
          if (input.value === '') {
            input.focus()
            break;
          }
        }
        if (this.customerName &&
          this.customerSecondName &&
          this.onOrderPhoneNumber &&
          this.customerCity &&
          this.customerPostNumber
        ) {
          focusedElement.blur()
        }
      })
    },
    computed: {
      getOrderId() {
        return this.$store.getters.getOrderId
      },
      cartElements() {
        return this.$store.getters.getCustomerCart;
    },
      customCustomerInfo() {
        return this.$store.getters.customCustomerInfo
      }
    },
    methods: {
      ...mapMutations(['setChangeCustomerInfo']),
        debouncedSearch: debounce(async function () {
          try {
            let data = {
              order_id: this.getOrderId.id,
              q: this.customerCity
            }
           let result = await GET_CITYS(data)
           this.searchedTowns = result.data
          } catch (error) {
            console.log(error.message)
          }
       }, 300),
       handleEnterKey() {
        const activeElement = document.activeElement
        if (activeElement.tagName === 'INPUT') {
          activeElement.blur()
          if (this.searchedTowns.length) {
            this.searchedTowns = []
          }
        }
       },
       setSaveCustomerInfo() {
        let data = {
        firstName: this.customerName,
        lastName: this.customerSecondName,
        phoneNumber: this.onOrderPhoneNumber,
        }
        this.setChangeCustomerInfo(data)
       },
        validatePhoneNumber() {
        const usaPhoneRegex = /^(\d{3})(\d{3})(\d{4})$/;
        if (this.onOrderPhoneNumber?.length > 9) {
         this.isValidPhoneNumber = usaPhoneRegex.test(this.onOrderPhoneNumber);
        }
        },
      isOpenKeyboard(value) {
        if (this.telegram.platform === 'tdesktop') {
          return
        }
        if (value) {
          this.telegram.MainButton.setParams({
            text: 'Готово',
            color: '#343745',
            text_color: '#fff'
          })
          this.telegram.MainButton.show()
          this.isHideMainButton = true
        } else {
          this.telegram.MainButton.hide()
          this.isHideMainButton = false
        }
      },
       setIsShowBranch() {
        this.isOpenKeyboard(true)
        if (!this.branchCity) {
          return
        }
        setTimeout(() => {
          this.isShowranch = true
        }, 300)
        setTimeout(() => {
          document.querySelector('.searched-input-post').focus()
        }, 800)
       },
       setHawePlusOnNumber(number) {
        console.log({number})
        if (number.startsWith("+")) {
          return number.slice(1)
        } else {
          return number
        }
       },
       setMakeOrder() {
        if (!this.isValidPhoneNumber) {
          return
        }
        if (
          !this.branchCity || 
          !this.usedBranch || 
          this.customerName?.length < 3 || 
          this.customerSecondName?.length < 3 ||
          !this.onOrderPhoneNumber.length
        ) {
        this.isRequiredError = true
          return
        }
        if (this.onOrderPhoneNumber.length < 10) {
          this.isValidPhoneNumber = false
        }
        this.isRequiredError = false
        this.isLoadingFetch = true
        let data = {
          order_id: this.getOrderId.id,
          uuid: this.usedBranch.id,
          delivery_phone: this.setHawePlusOnNumber(this.onOrderPhoneNumber),
          delivery_first_name: this.customerName,
          delivery_last_name: this.customerSecondName
        }
        try {
         let result = this.$store.dispatch('setSaveOrder', JSON.stringify(data))
         result
         .then(value => this.resultMakePrder = value.status)
         .catch(error => this.resultMakePrder = error)
        } catch (error) {
          console.log(error.message)
        }
       },
       onClickToCity(value) {
        if (!value.uuid_city) {
          this.searchedTowns = []
          return
        }
        this.branchCity = value
        this.customerCity = value.name
        this.searchedTowns = []
        this.onSearchCitysBranch()
       },
       onCLickToBranch(value) {
        this.usedBranch = value
        this.customerPostNumber = value.text
        this.isShowranch = false
       },
      async onSearchCitysBranch() {
        if (!this.branchCity) {
          return
        }
        this.isLoading = true
        try {
          let data = {
            order_id: this.getOrderId.id,
            uuid_city: this.branchCity.uuid_city
          }
          let result = await GET_ORDER_BRANCH(data)
          this.searchedBranch = result.data
        } catch (error) {
          console.log(error.message)
        }
        this.isLoading = false
       },
        setChangeCounter(value) {
            if (value === '+') {
                this.productCounter += 1
            } else {
                this.productCounter -= 1
            }
        },
    },
    watch: {
      customerPostNumber(newValue, oldVaue) {
        let val = oldVaue
        val
        this.filterPostText = newValue
      },
      branchCity(newValue, oldVaue) {
        let val = oldVaue
        val
        this.usedBranch = null
        this.customerPostNumber = ''
        this.searchedBranch = []
      },
      searchedBranch(newValue, oldVaue) {
        let val = oldVaue
        val
        this.filteredPostNumbers = newValue
      },
      filterPostText(newValue, oldValue) {
        let val = oldValue
        val
          if (newValue?.length >= 1) {
          const regex = new RegExp('.*' + newValue + '.*', 'i')
          let newArray = this.searchedBranch.filter(post => regex.test(post.text))
          this.filteredPostNumbers = newArray
          } else {
            this.filteredPostNumbers = this.searchedBranch
          }
      },
      resultMakePrder(newValue, oldValue) {
        let val = oldValue
        val
        this.isLoadingFetch = false
        if (newValue === true) {
          this.$emit('setIsChangePage', 'success')       
        } else {
          this.isShowError = true
        }
      },
    }
}
</script>

<style scoped>
.main-background {
    background: #fff;
}
.filter-page-back-button {
    position: relative;
    border-bottom: 1px solid #F0F0F0;
    padding: 18px;
    cursor: pointer;
}

.back-button-icon {
    position: absolute;
}

.back-button-text {
    text-align: center;
}

.filter-page-container {
    display: flex;
    flex-direction: column;
}

.bottom-filter-button-container {
    background: #FFF;
    box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
    padding: 16px;
    z-index: 100;
}

.filtration-button {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #343745;
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
    margin-bottom: 10px;
}

.return-to-shop {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #FFF;
    color: #343745;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
    margin-bottom: 10px;
    border: 1px solid #343745;
}

.final-price-container {
    display: flex;
    justify-content: space-between;
}
.final-price {
    color: #121212;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 5px;
}
.make-order-page-inputs-container {
  padding: 0 16px 5px 16px;
  margin-top: 4px;
  margin-bottom: 10px;
  overflow-y: scroll;
}

.make-order-input-container {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    position: relative;
}
.make-order-input-label {
    color: #707070;
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
}

.make-order-input {
    border-radius: 8px;
    border: 1px solid #D2D6DB;
    background: #FFF;
    color: #707070;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px 15px;
    margin-top: 4px;
    outline-color: #343745;
}

.make-order-page-title {
    margin-top: 16px;
    color: #121212;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
}

.make-order-page-main-title {
    color: #333;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
}

.make-order-page-under-main-title {
    color: #333;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 8px;
}

.searched-order-posts {
  position: fixed;
  width: 100%;
  max-height: 350px;
  padding: 10px;
  left: 0px;
  bottom: 0px;
  z-index: 101;
  background: #fff;
  overflow: hidden;
  transform: translateY(100%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: all .5s ease;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.searched-order-posts.show {
  transform: translateY(0);
}
.searched-order-towns {
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow: hidden;
  background-color: #ffffff;
  border: 1px solid #D2D6DB;
  border-radius: 8px;
  padding: 10px 5px;
  bottom: 45px;
}

.searched-order-town-item {
  padding: 10px;
  cursor: pointer;
  color: #707070;
  border-radius: 5px;
  transition: all .2s ease;
}

.searched-order-town-item:hover {
  background-color: #343745;
  color: #fff;
}

.branch-loading-container {
  display: flex;
  gap: 10px;
}

.branch-loading-text {
  color: #707070;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 25px;
}
.branch-loading-spinner {
  margin: auto 0;
}

.button-loading-spinner {
  margin: auto;
}
.perfect-town-scrollbar {
  height: 400px;
}

.searched-input-post {
 border-radius: 8px;
    border: 1px solid #D2D6DB;
    background: #FFF;
    color: #707070;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px 15px;
    margin-top: 4px;
    outline-color: #343745;
    width: 100%;
    margin-bottom: 10px;
}

.error-message-container {
  padding: 5px 10px;
}

.error-message-text {
  font-size: 12px;
    font-weight: 400;
    color: red;
}

</style>